import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { BuildingContactView } from '@api-proxies';
import { AppEditorFactory } from '@factories/app-editor-factory/app-editor-factory';
import { EditorType } from '@factories/app-editor-factory/enum/editor-type';
import { BuildingContactService } from '@http/clients/building-contact.service';
import { AwaiterService } from '@services/awaiter.service';
import { CDK_IMPORTS } from '@utils/standalone-imports';
import {
    EditorItemComponent,
    IconSanitizerService,
    IEditorItemConfig,
    ModalComponentBase,
    ObjectExtensionsService,
    SnackbarNotificationService
} from 'ngx-lib';
import { LoadingButtonComponent } from '../../loading-button/loading-button.component';

interface IModalEditBuildingContactParameters {
    contact: BuildingContactView;
}

@Component({
    selector: 'app-modal-edit-building-contact',
    templateUrl: './modal-edit-building-contact.component.html',
    styleUrls: ['./modal-edit-building-contact.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [...CDK_IMPORTS, EditorItemComponent, LoadingButtonComponent]
})
export class ModalEditBuildingContactComponent
    extends ModalComponentBase<IModalEditBuildingContactParameters, BuildingContactView>
    implements OnInit
{
    protected override parameters!: IModalEditBuildingContactParameters;

    contactFullName!: string;

    buildingName!: string;

    contact!: BuildingContactView;

    factory: AppEditorFactory;

    configItems: IEditorItemConfig[];

    contactInitialState!: BuildingContactView;

    isLoading: boolean;

    closeIcon: SafeHtml;

    constructor(
        private readonly buildingContactService: BuildingContactService,
        private readonly awaiter: AwaiterService,
        private readonly snackbarNotificationService: SnackbarNotificationService,
        private readonly objectExtensionService: ObjectExtensionsService,
        private readonly iconSanitizer: IconSanitizerService
    ) {
        super();
        this.factory = new AppEditorFactory();
        this.configItems = [];
        this.closeIcon = this.iconSanitizer.getIcon('closeModal');
        this.isLoading = false;
    }

    ngOnInit(): void {
        this.contactFullName = this.parameters?.contact.contactFullName ?? '';
        this.contact = this.parameters?.contact;
        this.contactInitialState = this.objectExtensionService.clone(this.parameters?.contact) as BuildingContactView;

        this.configItems = [
            {
                label: 'Contact Role',
                componentId: EditorType.buildingContactRole,
                fieldName: 'buildingContactRoleId',
                bindContext: this.contact
            }
        ];
    }

    async saveContact(): Promise<void> {
        await this.awaiter.awaitAction(
            'Saving Contact...',
            async () => {
                const buildingContactSaved = await this.buildingContactService.save(this.contact);

                if (buildingContactSaved) {
                    this.snackbarNotificationService.success('Contact saved successfully.');
                    this.close(buildingContactSaved);
                }
            },
            (loading) => (this.isLoading = loading)
        );
    }

    onClose() {
        this.contact = this.contactInitialState;
        this.close(this.contactInitialState);
    }
}
